import React, { useState } from 'react';

const DataTable = ({ 
  title, 
  columns, 
  data = [], 
  onAdd, 
  onView, 
  onEdit, 
  onDelete,
  renderActions, // New prop for custom actions
  searchPlaceholder = "Search...",
  addButtonText = "Add New"
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredData = data.filter(item => {
    if (!searchTerm) return true;
    return columns.some(col => {
      const value = item[col.key];
      return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    });
  });

  return (
    <div className="admin-crud-card">
      <div className="admin-crud-card-header">
        <h3 className="admin-crud-title">
          <span className="admin-crud-title-icon">📋</span>
          {title}
        </h3>
        <div className="admin-crud-actions">
          <div className="admin-crud-search-box">
            <input
              type="text"
              className="admin-crud-search-input"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="admin-crud-search-icon">🔍</span>
          </div>
          <button 
            className="admin-crud-btn admin-crud-btn-primary"
            onClick={onAdd}
          >
            ➕ {addButtonText}
          </button>
        </div>
      </div>

      <div className="admin-crud-table-wrapper">
        <table className="admin-crud-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx}>{col.header}</th>
              ))}
              <th style={{ width: '180px' }}>Actions</th>
            </tr>
          </thead>
    <tbody>
      {filteredData.length > 0 ? (
        filteredData.map((item) => (
          <tr key={item.id}>
            {columns.map((col, idx) => (
              <td key={idx}>
                {col.render ? col.render(item[col.key], item) : item[col.key]}
              </td>
            ))}
            <td>
              {renderActions 
                ? renderActions(item)
                : (
                  <div className="admin-crud-actions-group">
                    {onView && (
                      <button className="admin-crud-action-btn admin-crud-action-view" onClick={() => onView(item)}>
                        👁️ View
                      </button>
                    )}
                    {onEdit && (
                      <button className="admin-crud-action-btn admin-crud-action-edit" onClick={() => onEdit(item)}>
                        ✏️ Edit
                      </button>
                    )}
                    {onDelete && (
                      <button className="admin-crud-action-btn admin-crud-action-delete" onClick={() => onDelete(item)}>
                        🗑️ Delete
                      </button>
                    )}
                  </div>
                )
              }
            </td>
          </tr>
        ))
      ) : (
        // ... empty state ...
        <h1></h1>
      )}
    </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;